module.exports = __webpack_public_path__ + "files/18e6c9d0f263d6707df5728c544de4a8.png";